<template>
    <div>
    <the-headersider></the-headersider>
    <base-card>
   
<!-- 
    <div class="form-outline">
  <input type="search" id="form1" class="form-control" v-model="search" placeholder="Search client"  aria-label="Search"  />
</div> -->

<!-- clients {{ copClients }} -->
    
   <!-- cop c {{ copClients }} -->
  
<table class="table table-striped table-bordered">
        <thead>
            <tr >
                <th>Name</th>
                <th>phone</th>
                <th>Address</th>
                <!-- <th>court</th> -->
                <th>KRA PIN</th>
                <!-- <th>Out standing Amt</th> -->
                <!-- <th>Is Active</th> -->
            </tr>
            </thead> 
            <tbody>
                
                <tr v-for="client in copClients" :key="client.id">
                    <td><a :href="'/invoices/client/' + client.client_id"> {{ client.name }} </a></td>
                    
                    <!-- <td>{{ client.name}}</td>  -->
                    <td>{{ client.phone}}</td>
                    <td>{{ client.address}}</td>
                    <!-- <td>{{ client.court}}</td> -->
                    <td>{{ client.kra_pin}}</td>
                    <!-- <td>{{ client.arrears}}</td>
                    <td>{{ client.isActive}}</td> -->
                    
                </tr>
            </tbody>
    </table>
    <router-link to="/corporate/client/registration">Register clients</router-link>

    
</base-card>
<br>
<!-- <button class="btn btn-success" @click="downloadPDF">Download all clients </button> -->

</div>
</template>
<script>

// import jsPDF from "jspdf";

require('jspdf-autotable');

export default {
    // data() {
    // return {
    //   search: "",
    // };
//  
    computed: {
        // clients() {
        //     return  this.$store.getters.clients

            
        // },
        copClients(){
            return this.$store.getters.corporateClients

        },
       
    //     filteredClients() {
    //   return this.clients.filter((client)=>client.name.toLowerCase().includes(this.search.toLowerCase())| client.client_id.toString().includes(this.search.toLocaleLowerCase())| client.phone.toString().includes(this.search.toLowerCase())).slice(0,6)
        
       
    // },

    },
     created() {
    // this.$store.dispatch('LoadClients'); 
    this.$store.dispatch('LoadCorporateclients');  
    
    
  },
  methods: {
    
  
  },

}

</script>
